<td-wb-modal-header iconId="modal--info">
  <td-wb-modal-header-title modalTitle="tdWb.messages.modal.TITLE" />
  <td-wb-modal-header-buttons>
    <td-wb-modal-close-button />
  </td-wb-modal-header-buttons>
</td-wb-modal-header>
<td-wb-modal-panel [top]="true"
                   [bottom]="true">
  <td-wb-form>
    <td-wb-messages-group [messages]="messages"
                          [priorityOnly]="true"
                          [expandMessages]="true" />
    <td-wb-form-footer class="td-wb-messages-modal-form-footer">
      <td-wb-form-footer-end class="td-wb-form-footer-end">
        <button id="markAsReadAndDismiss"
                tdWbButton
                tdWbButtonType="primary"
                class="td-wb-messages-modal-form-footer-button"
                (click)="markAsReadAndDismiss()">
          <span translate="tdWb.messages.modal.CONTINUE"></span>
        </button>
      </td-wb-form-footer-end>
    </td-wb-form-footer>
  </td-wb-form>
</td-wb-modal-panel>
